export const locationsAr = {
  locations: {
    type: {
      factory: 'مصنع',
      office: 'مكتب',
      unknown: 'غير معروف',
    },
  },
  header: {
    selectLocation: 'اختر الموقع',
    searchLocations: 'بحث عن المواقع...',
    allLocations: 'جميع المواقع',
  },
}
